import config from 'SRC/config/config.yaml'

export const defaultDial = config.defaultDial
